<router-outlet />
<global-spinner></global-spinner>
